import React from "react";

import { useDispatch, useSelector } from "react-redux";
import reducer, { devicesActions, applicationsActions } from "../../store";

import { map } from "../map";

import styles from "../../../styles/map.module.css";
import { NotificationManager } from "react-notifications";

export const selectedItemRef = React.createRef();

const DevicesList = () => {
    const devices = Object.values(reducer.getState().devices.items);
    const selectedId = useSelector((state) => state.devices.selectedId);
    const dispatch = useDispatch();

    return (
        <div className={styles.device} style={{ height: Object.keys(devices).length === 1 ? 110 : 300 }}>
            <div className={styles.text_head_sticky}>دستگاه ها</div>
            <div className={styles.deviceList}>
                {devices.map((device) => {
                    return (
                        <div
                            ref={selectedId === device.id ? selectedItemRef : undefined}
                            className={selectedId === device.id ? styles.item_select : styles.item}
                            key={device.id}
                            onClick={() => {
                                if (device.id !== selectedId) dispatch(devicesActions.select(device.id));
                                let position = Object.values(reducer.getState().positions.items).filter((x) => x.deviceId === device.id);
                                if (position.length !== 0) {
                                    map.flyTo({ center: [position[0].longitude, position[0].latitude], zoom: 14 });
                                    dispatch(applicationsActions.dialog(undefined));
                                } else {
                                    NotificationManager.warning("برای این دستگاه موقعیتی ثبنت نشده است", "", 2500);
                                }
                            }}
                        >
                            {device.name}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default DevicesList;
